export const RATE_THRESHOLD = 50000
export const CUSTOM_RATE_THRESHOLD = 200000
